import { ObjectTypes } from "@common/enums/object-types";
import { Record } from './record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { LocationList } from '../complex-types/location-list';

export class UserRecord extends Record {
    constructor() {
        super();
        this.type = ObjectTypes.USER;
        this.locations = new LocationList();
    }

    public get locations(): LocationList { return this.getAs<LocationList>(PSTFieldNames.RSLocation); }
    public set locations(value: LocationList) { this.set(PSTFieldNames.RSLocation, value); }

}
